(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cuon-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(customElements.get('cuon-faq'))return;
 customElements.define('cuon-faq',class extends HTMLElement{
  connectedCallback(){
   if(this.querySelector('[data-cfq-ready]'))this.init();
   else{this.childObserver=new MutationObserver(()=>{if(this.querySelector('[data-cfq-ready]')){this.childObserver.disconnect();this.init();}});this.childObserver.observe(this,{childList:true,subtree:true});}
  }
  init(){
   if(this.lifecycle&&!this.lifecycle.signal.aborted)return;
   this.lifecycle=new AbortController();this.animations=new Map();this.items=[...this.querySelectorAll('.cfq__item')];const options={signal:this.lifecycle.signal};
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.items.forEach(item=>this.sync(item,item.open));
   this.addEventListener('click',event=>{
    const summary=event.target.closest?.('.cfq__summary');if(!summary||summary.closest('cuon-faq')!==this)return;
    event.preventDefault();this.setOpen(summary.parentElement,!this.isOpen(summary.parentElement));
   },options);
   this.addEventListener('shopify:block:select',event=>{const item=this.items.find(el=>el.dataset.cfqBlock===event.detail?.blockId);if(item)this.setOpen(item,true,true);},options);
   window.addEventListener('resize',()=>this.finishAll(),options);
   this.motion.addEventListener('change',()=>this.finishAll(),options);
  }
  isOpen(item){return item.dataset.targetOpen?item.dataset.targetOpen==='true':item.open;}
  sync(item,open){
   const summary=item.querySelector('summary'),panel=item.querySelector('.cfq__panel');
   if(!open&&panel.contains(document.activeElement))summary.focus({preventScroll:true});
   summary.setAttribute('aria-expanded',String(open));panel.inert=!open;panel.setAttribute('aria-hidden',String(!open));
  }
  finish(item){
   const open=this.isOpen(item);const animation=this.animations.get(item);this.animations.delete(item);animation?.cancel();
   item.open=open;item.style.removeProperty('height');item.style.removeProperty('overflow');delete item.dataset.targetOpen;this.sync(item,open);
  }
  finishAll(){for(const item of [...(this.animations?.keys()||[])])this.finish(item);}
  setOpen(item,open,instant=false){
   if(open&&this.dataset.single==='true')this.items.forEach(other=>{if(other!==item&&this.isOpen(other))this.setOpen(other,false,instant);});
   if(this.isOpen(item)===open){if(instant)this.finish(item);return;}
   const from=item.getBoundingClientRect().height;this.animations.get(item)?.cancel();this.animations.delete(item);
   item.style.removeProperty('height');item.style.removeProperty('overflow');delete item.dataset.targetOpen;
   const configured=parseFloat(getComputedStyle(this).getPropertyValue('--cfq-duration'));const duration=Number.isFinite(configured)?Math.max(0,configured):280;
   this.sync(item,open);
   if(instant||!duration||this.motion.matches||typeof item.animate!=='function'){item.open=open;return;}
   item.open=open;const to=item.getBoundingClientRect().height;item.open=true;item.dataset.targetOpen=String(open);item.style.height=`${from}px`;item.style.overflow='hidden';
   const animation=item.animate([{height:`${from}px`},{height:`${to}px`}],{duration,easing:'cubic-bezier(0.22, 1, 0.36, 1)',fill:'forwards'});
   this.animations.set(item,animation);animation.onfinish=()=>{if(this.animations.get(item)===animation)this.finish(item);};
  }
  disconnectedCallback(){this.childObserver?.disconnect();this.finishAll();this.lifecycle?.abort();}
 });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuon-featured-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(customElements.get('cuon-featured-reviews'))return;
 customElements.define('cuon-featured-reviews',class extends HTMLElement{
  connectedCallback(){
   if(this.querySelector('[data-fr-ready]'))this.init();
   else{this.observer=new MutationObserver(()=>{if(this.querySelector('[data-fr-ready]')){this.observer.disconnect();this.init();}});this.observer.observe(this,{childList:true,subtree:true});}
  }
  init(){
   if(this.controller&&!this.controller.signal.aborted)return;
   this.rail=this.querySelector('[data-fr-rail]');if(!this.rail)return;
   this.cards=[...this.querySelectorAll('[data-fr-card]')];this.controller=new AbortController();const options={signal:this.controller.signal};
   const go=index=>{const card=this.cards[index];if(card)this.rail.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
   this.rail.addEventListener('keydown',event=>{
    if(event.target!==this.rail)return;
    let current=0;this.cards.forEach((card,i)=>{if(Math.abs(card.offsetLeft-this.cards[0].offsetLeft-this.rail.scrollLeft)<Math.abs(this.cards[current].offsetLeft-this.cards[0].offsetLeft-this.rail.scrollLeft))current=i;});
    let next;if(event.key==='ArrowRight')next=Math.min(this.cards.length-1,current+1);else if(event.key==='ArrowLeft')next=Math.max(0,current-1);else if(event.key==='Home')next=0;else if(event.key==='End')next=this.cards.length-1;else return;
    event.preventDefault();go(next);
   },options);
   this.addEventListener('shopify:block:select',event=>{const index=this.cards.findIndex(card=>card.dataset.frBlock===event.detail?.blockId);if(index>=0)go(index);},options);
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
 });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuon-five-steps"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('cuon-five-steps')) return;
 class CuonFiveSteps extends HTMLElement {
  connectedCallback() {
   if (this.querySelector('[data-cf-ready]')) this.initialize();
   else {
    this.observer=new MutationObserver(()=>{
     if (!this.querySelector('[data-cf-ready]')) return;
     this.observer.disconnect();this.initialize();
    });
    this.observer.observe(this,{childList:true,subtree:true});
   }
  }
  initialize() {
   if (this.controller && !this.controller.signal.aborted) return;
   this.viewport=this.querySelector('[data-cf-viewport]');
   if (!this.viewport) return;
   this.controller=new AbortController();const signal=this.controller.signal;
   this.viewport.addEventListener('keydown',event=>{
    if (event.target!==this.viewport || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const cards=[...this.querySelectorAll('[data-cf-card]')];
    if (!cards.length) return;
    const current=this.viewport.scrollLeft;
    const positions=cards.map(card=>card.offsetLeft-cards[0].offsetLeft);
    const maximum=this.viewport.scrollWidth-this.viewport.clientWidth;
    let left=0;
    if(event.key==='End')left=maximum;
    else if(event.key==='ArrowRight')left=positions.find(p=>p>current+2)??maximum;
    else if(event.key==='ArrowLeft')left=positions.filter(p=>p<current-2).pop()??0;
    this.viewport.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   },{signal});
   this.viewport.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0)return;
    this.drag={id:event.pointerId,x:event.clientX,left:this.viewport.scrollLeft,active:false};
   },{passive:true,signal});
   this.viewport.addEventListener('pointermove',event=>{
    if(!this.drag||this.drag.id!==event.pointerId)return;
    const delta=event.clientX-this.drag.x;
    if(!this.drag.active&&Math.abs(delta)>6){
     this.drag.active=true;this.viewport.dataset.dragging='';this.viewport.setPointerCapture?.(event.pointerId);
    }
    if(!this.drag.active)return;
    event.preventDefault();this.viewport.scrollLeft=this.drag.left-delta;
   },{signal});
   const release=()=>{this.drag=null;delete this.viewport.dataset.dragging;};
   window.addEventListener('pointerup',release,{signal});window.addEventListener('pointercancel',release,{signal});window.addEventListener('blur',release,{signal});
   document.addEventListener('shopify:block:select',event=>{
    const card=event.target.closest?.('[data-cf-card]');
    if(!card||!this.contains(card))return;
    const first=this.querySelector('[data-cf-card]');
    this.viewport.scrollTo({left:card.offsetLeft-first.offsetLeft,behavior:'auto'});
   },{signal});
   this.addEventListener('error',event=>{
    if(event.target.matches?.('.cf__image'))event.target.hidden=true;
   },{capture:true,signal});
   this.querySelectorAll('.cf__image').forEach(image=>{if(image.complete&&!image.naturalWidth)image.hidden=true;});
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.drag=null;if(this.viewport)delete this.viewport.dataset.dragging;}
 }
 customElements.define('cuon-five-steps',CuonFiveSteps);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuon-formula"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(customElements.get('cuon-formula'))return;
 class CuonFormula extends HTMLElement {
  connectedCallback(){
   if(this.querySelector('[data-pf-ready]'))this.initialize();
   else{this.childrenObserver=new MutationObserver(()=>{if(this.querySelector('[data-pf-ready]')){this.childrenObserver.disconnect();this.initialize();}});this.childrenObserver.observe(this,{childList:true,subtree:true});}
  }
  initialize(){
   if(this.lifecycle&&!this.lifecycle.signal.aborted)return;
   this.lifecycle=new AbortController();const signal=this.lifecycle.signal;
   this.toggle=this.querySelector('[data-pf-toggle]');this.dialog=this.querySelector('[data-pf-dialog]');this.more=this.querySelector('[data-pf-more]');
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=false;this.visible=typeof IntersectionObserver!=='function';this.failed=false;
   this.images=[...this.querySelectorAll('.pf__image')];
   this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.sync();},{signal});
   this.motion.addEventListener('change',()=>this.sync(),{signal});
   document.addEventListener('visibilitychange',()=>this.sync(),{signal});
   for(const img of this.images){img.addEventListener('load',()=>this.sync(),{signal});img.addEventListener('error',()=>{img.hidden=true;this.failed=true;this.sync();},{signal});if(img.complete&&!img.naturalWidth){img.hidden=true;this.failed=true;}}
   if(this.dialog&&typeof this.dialog.showModal==='function'&&this.more){
    this.more.hidden=false;
    this.more.addEventListener('click',()=>{if(!this.dialog.open)this.dialog.showModal();this.sync();},{signal});
    this.querySelector('[data-pf-close]').addEventListener('click',()=>this.dialog.close(),{signal});
    this.dialog.addEventListener('close',()=>{if(this.isConnected)this.more.focus({preventScroll:true});this.sync();},{signal});
    this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const b=this.dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();},{signal});
   }
   if(typeof IntersectionObserver==='function'){
    this.visibilityObserver=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();});this.visibilityObserver.observe(this);
   }
   this.sync();
  }
  sync(){
   if(this.lifecycle?.signal.aborted)return;
   const ready=this.images.length===3&&!this.failed&&this.images.every(img=>img.complete&&img.naturalWidth>0);
   const enabled=this.dataset.animate==='true'&&!this.motion.matches&&!navigator.connection?.saveData&&ready;
   this.dataset.mode=enabled?'animated':'static';
   this.dataset.running=String(enabled&&this.visible&&!document.hidden&&!this.paused&&!this.dialog?.open);
   this.toggle.hidden=!enabled;this.toggle.setAttribute('aria-pressed',String(this.paused));
   const label=this.paused?'Animasyonu başlat':'Animasyonu duraklat';this.toggle.setAttribute('aria-label',label);this.toggle.title=label;
  }
  disconnectedCallback(){
   this.childrenObserver?.disconnect();this.lifecycle?.abort();this.visibilityObserver?.disconnect();
   this.dataset.running='false';if(this.dialog?.open)this.dialog.close();
  }
 }
 customElements.define('cuon-formula',CuonFormula);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuon-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cuon-product')) return;
  class CuonProduct extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.childObserver?.disconnect();
      if (this.querySelector('[data-cuon-ready]')) this.initialize();
      else {
        this.childObserver = new MutationObserver(() => {
          if (!this.querySelector('[data-cuon-ready]')) return;
          this.childObserver.disconnect();
          this.initialize();
        });
        this.childObserver.observe(this, { childList: true, subtree: true });
      }
    }
    initialize() {
      this.lifecycle?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.feedbackTimer);
      this.clearAccordions();
      this.initialized = false;
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      try {
        this.config = JSON.parse(this.dataset.config);
        this.variants = JSON.parse(this.dataset.variants);
        if (!Array.isArray(this.variants)) throw new TypeError('Invalid product variants');
      } catch (error) {
        this.querySelector('[data-add]')?.setAttribute('disabled', '');
        this.message(this.dataset.initError, true);
        console.warn('CUON product initialization failed:', error.message);
        return;
      }
      this.variant = this.variants.find(v => v.id === this.config.variantId) || this.variants[0];
      this.offers = [...this.querySelectorAll('[data-offer]')];
      this.initialized = true;
      this.form = this.querySelector('form[data-cuon-product-form], form.cp__form');
      try { this.money = new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency: this.config.currency || 'TRY' }); }
      catch { this.money = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }); }
      const root = window.Shopify?.routes?.root || this.config.root || '/';
      this.root = root.endsWith('/') ? root : root + '/';
      this.addEventListener('change', event => {
        if (event.target.matches('[data-offer]')) this.update();
        if (event.target.matches('[data-variant]')) {
          this.variant = this.variants.find(v => String(v.id) === event.target.value);
          this.update();
          const index = this.slides?.findIndex(slide => slide.dataset.mediaId === String(this.variant?.media));
          if (index >= 0) this.goTo(index);
        }
      }, { signal });
      this.addEventListener('click', event => {
        const summary = event.target.closest?.('.cp__accordion > summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        this.toggleAccordion(summary.parentElement);
      }, { signal });
      window.addEventListener('click', event => {
        const button = event.target.closest?.('[data-add], [data-sticky-add]');
        if (!button || button.closest('cuon-product') !== this || !this.form || button.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addToCart();
      }, { capture: true, signal });
      window.addEventListener('submit', event => {
        if (event.target !== this.form) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addToCart();
      }, { capture: true, signal });
      this.addEventListener('pointerdown', event => {
        const button = event.target.closest?.('[data-add]');
        if (button && !button.disabled) button.setAttribute('data-pressed', '');
      }, { signal });
      for (const type of ['pointerup', 'pointercancel', 'blur']) window.addEventListener(type, () => this.querySelector('[data-add]')?.removeAttribute('data-pressed'), { signal });
      document.addEventListener('shopify:block:select', event => {
        const details = event.target.closest?.('.cp__accordion');
        if (details && this.contains(details)) {
          this.clearAccordions(details);
          details.open = true;
        }
        const slide = event.target.closest?.('[data-slide]');
        if (slide && this.contains(slide)) this.goTo(this.slides?.indexOf(slide));
      }, { signal });
      try { this.setupGallery(signal); }
      catch (error) { console.warn('CUON gallery initialization failed:', error.message); }
      this.setupStickyGallery(signal);
      this.setupStickyCart(signal);
      this.update();
      const selectedMedia = this.slides?.findIndex(slide => slide.dataset.mediaId === String(this.variant?.media));
      if (selectedMedia >= 0) this.goTo(selectedMedia, false);
    }
    disconnectedCallback() {
      this.childObserver?.disconnect();
      clearTimeout(this.feedbackTimer);
      this.clearAccordions();
      this.lifecycle?.abort();
      this.initialized = false;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      const button = this.querySelector('[data-add]');
      button?.removeAttribute('aria-busy');
      button?.removeAttribute('data-state');
      button?.removeAttribute('data-pressed');
      this.querySelectorAll('video').forEach(video => video.pause());
    }
    clearAccordions(target) {
      for (const [details, animation] of this.accordionAnimations || []) {
        if (target && details !== target) continue;
        animation.cancel();
        details.open = details.dataset.targetOpen === 'true';
        details.style.removeProperty('height');
        details.style.removeProperty('overflow');
        delete details.dataset.targetOpen;
        this.accordionAnimations.delete(details);
      }
    }
    toggleAccordion(details) {
      this.accordionAnimations ||= new Map();
      const opening = !(details.dataset.targetOpen ? details.dataset.targetOpen === 'true' : details.open);
      const from = details.getBoundingClientRect().height;
      this.accordionAnimations.get(details)?.cancel();
      this.accordionAnimations.delete(details);
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      delete details.dataset.targetOpen;
      const configured = parseFloat(getComputedStyle(this).getPropertyValue('--cp-accordion-duration'));
      const duration = Number.isFinite(configured) ? Math.max(0, configured) : 240;
      if (!duration || matchMedia('(prefers-reduced-motion: reduce)').matches || typeof details.animate !== 'function') {
        details.open = opening;
        return;
      }
      details.open = opening;
      const to = details.getBoundingClientRect().height;
      details.open = true;
      details.dataset.targetOpen = String(opening);
      details.style.height = `${from}px`;
      details.style.overflow = 'hidden';
      const animation = details.animate([{ height: `${from}px` }, { height: `${to}px` }], { duration, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });
      this.accordionAnimations.set(details, animation);
      animation.onfinish = () => {
        if (this.accordionAnimations.get(details) !== animation) return;
        details.open = opening;
        animation.cancel();
        details.style.removeProperty('height');
        details.style.removeProperty('overflow');
        delete details.dataset.targetOpen;
        this.accordionAnimations.delete(details);
      };
    }
    get offer() { return this.offers.find(input => input.checked); }
    quantity(offer = this.offer) { return Number(offer?.dataset.quantity || this.variant?.rule?.min || 1); }
    validQuantity(quantity) {
      const rule = this.variant?.rule || {};
      return Number.isSafeInteger(quantity) && quantity >= (rule.min || 1) && (!rule.max || quantity <= rule.max) && quantity % (rule.increment || 1) === 0;
    }
    percentage(offer = this.offer) { return Math.min(100, Math.max(0, Number(offer?.dataset.percent) || 0)); }
    total(offer = this.offer) {
      const unit = this.variant?.price || 0;
      return Math.round(unit * this.quantity(offer) * (100 - this.percentage(offer)) / 100);
    }
    update() {
      if (!this.initialized || !this.variant) return;
      if (this.offers.length && (!this.offer || !this.validQuantity(this.quantity()))) {
        const availableOffer = this.offers.find(input => this.validQuantity(this.quantity(input)));
        if (availableOffer) availableOffer.checked = true;
      }
      this.offers.forEach(input => {
        input.disabled = !this.validQuantity(this.quantity(input)) || CuonProduct.busy;
        const price = input.closest('.cp__offer').querySelector('[data-offer-price]');
        if (price) price.textContent = this.money.format(this.total(input) / 100);
      });
      const quantity = this.quantity();
      const total = this.total();
      const price = this.querySelector('[data-active-price]');
      const unit = this.querySelector('[data-unit-price]');
      if (price) price.textContent = this.money.format(total / 100);
      if (unit) unit.textContent = `${quantity} ${this.config.unitLabel} / ${this.money.format(total / quantity / 100)} ${this.config.unitLabel}`;
      const variantInput = this.querySelector('[data-variant-input]');
      const quantityInput = this.querySelector('[data-quantity-input]');
      if (variantInput) variantInput.value = this.variant.id;
      if (quantityInput) quantityInput.value = quantity;
      const variantSelect = this.querySelector('[data-variant]');
      if (variantSelect) variantSelect.disabled = CuonProduct.busy;
      const button = this.querySelector('[data-add]');
      const available = this.variant.available && this.validQuantity(quantity) && !this.config.requiresPlan;
      if (button) {
        button.disabled = !available || CuonProduct.busy;
        const label = button.querySelector('[data-add-label]');
        if (label) label.textContent = this.submitting ? this.config.adding : this.variant.available ? this.config.addLabel : this.config.soldOut;
      }
      if (!this.validQuantity(quantity) || this.config.requiresPlan) this.message(this.config.ruleError, true);
      else if (!this.submitting) this.message('');
      this.syncStickyCart?.();
    }
    message(text, error = false, cartLink = false) {
      const status = this.querySelector('[data-status]');
      if (status) {
        status.textContent = text || '';
        status.hidden = !text;
        status.toggleAttribute('data-error', error);
        status.toggleAttribute('data-success', !!text && !error);
      }
      const link = this.querySelector('[data-cart-link]');
      if (link) link.hidden = !cartLink || !error;
      const stickyError = this.querySelector('[data-sticky-error]');
      if (stickyError) {
        stickyError.textContent = error ? text || '' : '';
        stickyError.hidden = !error || !text;
      }
      const stickyLink = this.querySelector('[data-sticky-link]');
      if (stickyLink) stickyLink.hidden = !cartLink || !error;
    }
    async request(path, body, lifecycle = this.lifecycle.signal) {
      const controller = new AbortController();
      const abort = () => controller.abort();
      if (lifecycle.aborted) controller.abort();
      else lifecycle.addEventListener('abort', abort, { once: true });
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(this.root + path, {
          method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
          ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok) {
          const error = new Error(typeof result.description === 'string' ? result.description : this.config.error);
          error.confirmed = true;
          throw error;
        }
        return result;
      } finally {
        clearTimeout(timer);
        lifecycle.removeEventListener('abort', abort);
      }
    }
    async addToCart() {
      if (!this.initialized || !this.isConnected || CuonProduct.busy || !this.variant?.available || !this.validQuantity(this.quantity()) || this.config.requiresPlan) return;
      const lifecycle = this.lifecycle.signal;
      CuonProduct.busy = true;
      this.submitting = true;
      document.querySelectorAll('cuon-product').forEach(section => section.update?.());
      const button = this.querySelector('[data-add]');
      clearTimeout(this.feedbackTimer);
      button?.removeAttribute('data-pressed');
      button?.setAttribute('data-state', 'loading');
      button?.setAttribute('aria-busy', 'true');
      const label = button?.querySelector('[data-add-label]');
      if (label) label.textContent = this.config.adding;
      this.message('');
      const variantId = this.variant.id;
      const quantity = this.quantity();
      const sections = [...new Set([
        ...[...document.querySelectorAll('[data-cuon-cart-section-id]')].map(el => el.dataset.cuonCartSectionId),
        ...[...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId)
      ].filter(Boolean))].slice(0, 5);
      const render = sections.length ? { sections, sections_url: location.pathname } : {};
      let added = false;
      let mutationStarted = false;
      let cart;
      let html;
      let failure;
      try {
        mutationStarted = true;
        const addition = await this.request('cart/add.js', { items: [{ id: variantId, quantity }], ...render }, lifecycle);
        added = true;
        html = addition.sections;
        if (!lifecycle.aborted) cart = await this.request('cart.js', undefined, lifecycle);
      } catch (error) {
        failure = added || (mutationStarted && !error.confirmed) ? this.config.uncertain : error.confirmed ? error.message : this.config.error;
        if (mutationStarted && !error.confirmed && !cart && !lifecycle.aborted) {
          try {
            cart = await this.request('cart.js', undefined, lifecycle);
            if (added) failure = undefined;
          } catch { /* Only reconcile with a read; never repeat an uncertain add. */ }
        }
      } finally {
        CuonProduct.busy = false;
        this.submitting = false;
        document.querySelectorAll('cuon-product').forEach(section => section.update?.());
        if (!lifecycle.aborted && this.isConnected) {
          button?.removeAttribute('aria-busy');
          button?.setAttribute('data-state', failure ? 'idle' : 'success');
          this.feedbackTimer = setTimeout(() => button?.removeAttribute('data-state'), 1100);
        }
      }
      if (lifecycle.aborted || !this.isConnected) return;
      this.message(failure || this.config.added, !!failure, !!failure);
      if (cart) this.notifyCart(cart, html, variantId, quantity, !failure);
      if (!failure && this.config.afterAdd === 'cart') location.assign(this.config.cartUrl);
    }
    notifyCart(cart, sections, variantId, quantity, success) {
      const customTrigger = document.querySelector('[data-cuon-cart-open]');
      const shouldOpen = success && this.config.afterAdd === 'drawer';
      const nativeDrawers = [...document.querySelectorAll('cart-drawer-component[auto-open]')];
      if (!shouldOpen || customTrigger) nativeDrawers.forEach(drawer => drawer.removeAttribute('auto-open'));
      try {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
          resource: cart, sourceId: this.id,
          data: { source: 'product-form-component', productId: this.config.productId, itemCount: quantity, variantId, sections: sections || {} }
        } }));
      } finally {
        nativeDrawers.forEach(drawer => drawer.setAttribute('auto-open', ''));
      }
      const integratedHeader = customTrigger?.closest('.cuon-noir-header')?.querySelector('[data-cuon-cart][data-cuon-product-events="true"]');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sections, source: 'cuon-product', added: success, openDrawer: shouldOpen } }));
      if (shouldOpen && customTrigger && !integratedHeader) customTrigger.click();
      else if (shouldOpen && integratedHeader) return;
      else if (shouldOpen) {
        const drawer = document.querySelector('cart-drawer-component');
        if (typeof drawer?.open === 'function') drawer.open();
        else if (typeof drawer?.showDialog === 'function') drawer.showDialog();
        else this.querySelector('[data-cart-link]')?.removeAttribute('hidden');
      }
    }
    setupStickyCart(signal) {
      const bar = this.querySelector('[data-sticky-cart]');
      const primary = this.querySelector('[data-add]');
      if (!bar || !primary || !this.form || typeof IntersectionObserver !== 'function') return;
      const button = bar.querySelector('[data-sticky-add]');
      const label = bar.querySelector('[data-sticky-label]');
      const image = bar.querySelector('[data-sticky-image]');
      const fallbackImage = image?.getAttribute('src');
      const title = this.querySelector('.cp__title')?.textContent.trim();
      if (title) bar.querySelector('[data-sticky-title]').textContent = title;
      let passed = false;
      const visibility = () => {
        const editing = document.activeElement?.matches('input:not([type]), input[type="text"], input[type="email"], input[type="tel"], input[type="search"], input[type="number"], input[type="url"], input[type="password"], textarea, [contenteditable="true"]');
        bar.hidden = !passed || !!editing;
      };
      // Observe only the original control; commerce stays in the existing form flow.
      const observer = new IntersectionObserver(([entry]) => {
        passed = !entry.isIntersecting && (window.innerWidth <= 749 || entry.boundingClientRect.bottom <= (entry.rootBounds?.top || 0));
        visibility();
      });
      observer.observe(primary);
      // Instant anchor jumps can skip both IntersectionObserver boundaries.
      let positionFrame = 0;
      const schedulePosition = () => {
        if (positionFrame) return;
        positionFrame = requestAnimationFrame(() => {
          positionFrame = 0;
          const rect = primary.getBoundingClientRect();
          passed = rect.bottom <= 0 || (window.innerWidth <= 749 && rect.top >= window.innerHeight);
          visibility();
        });
      };
      window.addEventListener('scroll', schedulePosition, { passive: true, signal });
      window.addEventListener('resize', schedulePosition, { passive: true, signal });
      const sync = () => {
        button.disabled = primary.disabled;
        label.textContent = primary.querySelector('[data-add-label]')?.textContent || this.config.addLabel;
        for (const name of ['data-state', 'aria-busy']) {
          if (primary.hasAttribute(name)) button.setAttribute(name, primary.getAttribute(name));
          else button.removeAttribute(name);
        }
        bar.querySelector('[data-sticky-price]').textContent = `${this.quantity()} ${this.config.unitLabel} · ${this.money.format(this.total() / 100)}`;
        if (image) {
          const media = this.slides?.find(slide => slide.dataset.mediaId === String(this.variant?.media));
          const mediaImage = media?.querySelector('img');
          const source = mediaImage?.getAttribute('src') || media?.querySelector('video')?.getAttribute('poster') || fallbackImage;
          if (source && image.getAttribute('src') !== source) image.setAttribute('src', source);
        }
      };
      const controlObserver = new MutationObserver(sync);
      controlObserver.observe(primary, { attributes: true, attributeFilter: ['disabled', 'data-state', 'aria-busy'], childList: true, subtree: true, characterData: true });
      this.syncStickyCart = sync;
      document.addEventListener('focusin', visibility, { signal });
      document.addEventListener('focusout', () => queueMicrotask(() => { if (!signal.aborted) visibility(); }), { signal });
      signal.addEventListener('abort', () => {
        cancelAnimationFrame(positionFrame);
        observer.disconnect();
        controlObserver.disconnect();
        bar.hidden = true;
        if (this.syncStickyCart === sync) this.syncStickyCart = null;
      }, { once: true });
      sync();
    }
    setupStickyGallery(signal) {
      const column = this.querySelector('.cp__gallery-column');
      if (!column || !this.hasAttribute('data-sticky-gallery')) return;
      let frame;
      let header;
      let observer;
      const sync = () => {
        frame = undefined;
        if (signal.aborted || !this.isConnected) return;
        if (!matchMedia('(min-width: 990px)').matches) {
          this.style.removeProperty('--cp-sticky-header');
          this.style.removeProperty('--cp-sticky-gallery-height');
          return;
        }
        let nextHeader = document.querySelector('.cuon-noir-header, #header-component, header-component');
        while (nextHeader && nextHeader !== document.body) {
          if (['fixed', 'sticky'].includes(getComputedStyle(nextHeader).position)) break;
          nextHeader = nextHeader.parentElement;
        }
        if (nextHeader === document.body) nextHeader = null;
        if (nextHeader !== header) {
          if (header) observer?.unobserve(header);
          header = nextHeader;
          if (header) observer?.observe(header);
        }
        const height = column.getBoundingClientRect().height;
        const headerHeight = header ? header.getBoundingClientRect().height + Math.max(0, parseFloat(getComputedStyle(header).top) || 0) : 0;
        for (const [name, value] of [['--cp-sticky-gallery-height', height], ['--cp-sticky-header', headerHeight]]) {
          const px = `${Math.ceil(value)}px`;
          if (this.style.getPropertyValue(name) !== px) this.style.setProperty(name, px);
        }
      };
      const schedule = () => { if (frame === undefined) frame = requestAnimationFrame(sync); };
      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(schedule);
        observer.observe(column);
      }
      window.addEventListener('resize', schedule, { passive: true, signal });
      this.addEventListener('load', schedule, { capture: true, signal });
      document.addEventListener('shopify:section:load', schedule, { signal });
      document.addEventListener('shopify:section:unload', schedule, { signal });
      signal.addEventListener('abort', () => {
        observer?.disconnect();
        cancelAnimationFrame(frame);
        this.style.removeProperty('--cp-sticky-header');
        this.style.removeProperty('--cp-sticky-gallery-height');
      }, { once: true });
      sync();
    }
    setupGallery(signal) {
      this.resizeObserver?.disconnect();
      this.activeSlide = undefined;
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;
      this.slides = [...this.track.querySelectorAll('[data-slide]')];
      const dots = this.querySelector('[data-dots]');
      const thumbs = this.querySelector('[data-thumbnails]');
      dots?.replaceChildren();
      thumbs?.replaceChildren();
      if (this.slides.length < 2) { if (dots) dots.hidden = true; if (thumbs) thumbs.hidden = true; return; }
      if (dots) dots.hidden = false;
      if (thumbs) thumbs.hidden = false;
      this.slides.forEach((slide, index) => {
        for (const [container, className] of [[dots, 'cp__dot'], [thumbs, 'cp__thumb']]) {
          if (!container) continue;
          const button = document.createElement('button');
          button.type = 'button'; button.className = className;
          button.setAttribute('aria-label', `${this.track.getAttribute('aria-label')} ${index + 1}`);
          button.setAttribute('aria-current', String(index === 0));
          if (container === thumbs) {
            const original = slide.querySelector('img');
            const url = original?.currentSrc || original?.src || slide.querySelector('video')?.poster;
            if (url) {
              const image = document.createElement('img');
              const small = new URL(url, location.href);
              if (/cdn\.shopify\.com$|\.myshopify\.com$/.test(small.hostname) || small.origin === location.origin) small.searchParams.set('width', '300');
              image.src = small.href; image.alt = ''; image.loading = 'lazy'; image.width = 147; image.height = 88;
              button.append(image);
            } else button.textContent = String(index + 1);
          }
          button.addEventListener('click', () => this.goTo(index), { signal });
          container.append(button);
        }
      });
      const scheduleMark = () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.markSlide());
      };
      this.track.addEventListener('scroll', scheduleMark, { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.goTo(Math.max(0, Math.min(this.slides.length - 1, (this.activeSlide || 0) + (event.key === 'ArrowRight' ? 1 : -1))));
      }, { signal });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(scheduleMark);
      this.resizeObserver.observe(this.track);
      scheduleMark();
    }
    goTo(index, animate = true) {
      const slide = this.slides?.[index];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: !animate || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    markSlide() {
      const rect = this.track.getBoundingClientRect();
      let active = 0; let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const diff = Math.abs(slide.getBoundingClientRect().left - rect.left);
        if (diff < distance) { distance = diff; active = index; }
      });
      if (this.activeSlide === active) return;
      this.activeSlide = active;
      for (const selector of ['[data-dots] button', '[data-thumbnails] button']) this.querySelectorAll(selector).forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
      this.slides.forEach((slide, index) => { if (index !== active) slide.querySelectorAll('video').forEach(video => video.pause()); });
    }
  }
  customElements.define('cuon-product', CuonProduct);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuon-ugc-creators"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cuon-creators')) return;
  class CuonCreators extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-ready]')) this.initialize();
      else {
        this.childrenObserver = new MutationObserver(() => {
          if (!this.querySelector('[data-ready]')) return;
          this.childrenObserver.disconnect();
          this.initialize();
        });
        this.childrenObserver.observe(this, { childList: true, subtree: true });
      }
    }
    initialize() {
      if (this.lifecycle && !this.lifecycle.signal.aborted) return;
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.original = this.querySelector('[data-original]');
      this.toggle = this.querySelector('[data-toggle]');
      if (!this.viewport || !this.original) return;
      this.reasons = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.auto !== 'true' || this.motion.matches || !!navigator.connection?.saveData;
      this.visible = typeof IntersectionObserver !== 'function';
      this.speed = Math.max(10, Math.min(80, Number(this.dataset.speed) || 26));
      this.direction = this.dataset.direction === 'right' ? -1 : 1;
      this.count = this.original.children.length;
      this.toggle.hidden = this.count < 2;
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.sync();
      }, { signal });
      this.motion.addEventListener('change', event => {
        if (event.matches) this.userPaused = true;
        this.sync();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        this.sync();
      }, { signal });
      this.viewport.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.hover === 'true') this.setReason('hover', true);
      }, { signal });
      this.viewport.addEventListener('pointerleave', () => this.setReason('hover', false), { signal });
      this.viewport.addEventListener('focusin', event => {
        if (event.target.matches(':focus-visible')) this.setReason('focus', true);
      }, { signal });
      this.viewport.addEventListener('focusout', event => {
        if (!this.viewport.contains(event.relatedTarget)) this.setReason('focus', false);
      }, { signal });
      this.viewport.addEventListener('wheel', () => this.manual(), { passive: true, signal });
      this.viewport.addEventListener('pointerdown', event => {
        this.setReason('pointer', true);
        clearTimeout(this.resumeTimer);
        if (event.pointerType === 'mouse' && event.button === 0 && !event.target.closest('button')) {
          this.drag = { id: event.pointerId, x: event.clientX, left: this.viewport.scrollLeft, active: false };
        }
      }, { passive: true, signal });
      this.viewport.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.active && Math.abs(delta) > 6) {
          this.drag.active = true;
          this.viewport.setPointerCapture?.(event.pointerId);
        }
        if (!this.drag.active) return;
        event.preventDefault();
        this.viewport.scrollLeft = this.drag.left - delta;
      }, { signal });
      const release = () => {
        this.drag = null;
        if (!this.reasons.has('pointer')) return;
        this.setReason('pointer', false);
        this.manual();
      };
      window.addEventListener('pointerup', release, { signal });
      window.addEventListener('pointercancel', release, { signal });
      window.addEventListener('blur', release, { signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.manual();
        const stride = this.period / Math.max(1, this.count);
        const left = event.key === 'Home' ? 0 : event.key === 'End' ? Math.max(0, this.period - stride) : this.viewport.scrollLeft + (event.key === 'ArrowRight' ? stride : -stride);
        this.viewport.scrollTo({ left, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }, { signal });
      this.addEventListener('error', event => {
        const image = event.target;
        if (!image.matches?.('img.cr__media')) return;
        image.hidden = true;
        image.closest('[data-card]')?.removeAttribute('data-has-media');
      }, { capture: true, signal });
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('[data-card]');
        if (!card || !this.original.contains(card)) return;
        this.setReason('editor', true);
        this.viewport.scrollLeft = card.offsetLeft - this.original.offsetLeft;
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (this.contains(event.target)) this.setReason('editor', false);
      }, { signal });
      if (typeof IntersectionObserver === 'function') {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        });
        this.visibilityObserver.observe(this);
      }
      this.measure(true);
      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.measure());
        });
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.original);
      } else window.addEventListener('resize', () => this.measure(), { passive: true, signal });
      this.sync();
    }
    measure(initial = false) {
      if (!this.isConnected || !this.viewport || this.lifecycle.signal.aborted) return;
      const width = this.viewport.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const period = this.original.getBoundingClientRect().width + gap;
      if (this.measuredWidth === width && this.period === period && !initial) return;
      const progress = this.period ? this.viewport.scrollLeft % this.period / this.period : 0;
      this.stop();
      this.measuredWidth = width;
      this.period = period;
      this.track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      if (period > 0 && width > 0 && this.count > 1) {
        const copies = Math.min(12, Math.ceil(width / period));
        for (let i = 0; i < copies; i++) {
          const clone = this.original.cloneNode(true);
          clone.removeAttribute('data-original');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('role');
          clone.querySelectorAll('*').forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
            node.removeAttribute('role');
          });
          clone.querySelectorAll('button,a,[tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
          this.track.append(clone);
        }
        this.viewport.scrollLeft = initial ? (this.original.firstElementChild?.getBoundingClientRect().width || 0) * .6447 : progress * period;
      } else this.viewport.scrollLeft = 0;
      this.sync();
    }
    setReason(reason, active) {
      if (active) this.reasons.add(reason); else this.reasons.delete(reason);
      this.sync();
    }
    manual() {
      this.setReason('manual', true);
      clearTimeout(this.resumeTimer);
      this.resumeTimer = setTimeout(() => this.setReason('manual', false), 1800);
    }
    sync() {
      if (this.lifecycle?.signal.aborted || !this.toggle) return;
      this.toggle.setAttribute('aria-pressed', String(this.userPaused));
      const label = this.userPaused ? 'Kaymayı başlat' : 'Kaymayı duraklat';
      this.toggle.setAttribute('aria-label', label);
      this.toggle.title = label;
      const run = !this.userPaused && this.visible && !document.hidden && !this.reasons.size && this.count > 1 && this.period > 0;
      if (run && !this.running) {
        this.running = true;
        this.dataset.running = 'true';
        this.position = this.viewport.scrollLeft;
        this.lastTime = null;
        this.frame = requestAnimationFrame(time => this.tick(time));
      } else if (!run) this.stop();
    }
    tick(time) {
      if (!this.running || !this.isConnected) return;
      const elapsed = this.lastTime == null ? 0 : Math.min(64, time - this.lastTime);
      this.lastTime = time;
      this.position = ((this.position + this.direction * this.speed * elapsed / 1000) % this.period + this.period) % this.period;
      this.viewport.scrollLeft = this.position;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    stop() {
      this.running = false;
      this.dataset.running = 'false';
      cancelAnimationFrame(this.frame);
      this.lastTime = null;
    }
    disconnectedCallback() {
      this.childrenObserver?.disconnect();
      this.lifecycle?.abort();
      this.stop();
      clearTimeout(this.resumeTimer);
      cancelAnimationFrame(this.resizeFrame);
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.track?.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      this.measuredWidth = undefined;
    }
  }
  customElements.define('cuon-creators', CuonCreators);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuon-usp-story-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.CuonUspStoryGallery) return;
  const instances = new Map();
  const init = (root) => {
    if (instances.has(root)) return;
    const stage = root.querySelector('[data-cuon-usp-stage]');
    const stageImage = root.querySelector('[data-cuon-usp-stage-image]');
    const viewport = root.querySelector('[data-cuon-usp-selector-viewport]');
    const selectors = [...root.querySelectorAll('[data-cuon-usp-selector]')];
    if (!stage || !stageImage || !viewport || !selectors.length) return;
    const pagers = [...root.querySelectorAll('[data-cuon-usp-desktop-pager]')];
    const counters = root.querySelectorAll('[data-cuon-usp-current], [data-cuon-usp-stage-current]');
    const progress = root.querySelector('[data-cuon-usp-progress]');
    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const sizes = '(max-width: 749px) calc(100vw - 32px), (max-width: 1440px) calc(100vw - 510px), 930px';
    let activeIndex = 0;
    let displayedIndex = 0;
    let frame = 0;
    let revealFrame = 0;
    let token = 0;
    let pending = null;
    const cancelPending = () => {
      token++;
      if (pending) { pending.onload = null; pending.onerror = null; pending = null; }
      if (revealFrame) cancelAnimationFrame(revealFrame);
      revealFrame = 0;
      stage.classList.remove('is-changing');
    };
    const indicators = (index) => {
      activeIndex = index;
      const number = String(index + 1).padStart(2, '0');
      counters.forEach(el => { el.textContent = number; });
      selectors.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-pressed', String(i === index));
      });
      pagers.forEach((el, i) => el.classList.toggle('is-active', i === index));
      if (progress) {
        const width = Math.ceil(132 / selectors.length);
        const travel = selectors.length > 1 ? (132 - width) / (selectors.length - 1) : 0;
        progress.style.width = `${width}px`;
        progress.style.transform = `translateX(${travel * index}px)`;
      }
    };
    const activate = (index, scroll = false) => {
      index = Math.max(0, Math.min(selectors.length - 1, index));
      const selector = selectors[index];
      cancelPending();
      indicators(index);
      if (scroll && mobile.matches) viewport.scrollTo({ left: selector.offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth' });
      const source = selector.dataset.cuonUspImage;
      const alt = selector.dataset.cuonUspAlt || '';
      if (!source) return;
      if (stageImage.getAttribute('src') === source && !stageImage.hidden) {
        stageImage.alt = alt;
        displayedIndex = index;
        return;
      }
      const currentToken = token;
      const preload = new Image();
      pending = preload;
      stage.classList.add('is-changing');
      preload.onload = () => {
        if (currentToken !== token || controller.signal.aborted || !root.isConnected) return;
        preload.onload = null; preload.onerror = null; pending = null;
        stageImage.sizes = sizes;
        if (selector.dataset.cuonUspSrcset) stageImage.srcset = selector.dataset.cuonUspSrcset;
        else stageImage.removeAttribute('srcset');
        stageImage.src = source;
        stageImage.alt = alt;
        stageImage.hidden = false;
        displayedIndex = index;
        revealFrame = requestAnimationFrame(() => { revealFrame = 0; stage.classList.remove('is-changing'); });
      };
      preload.onerror = () => {
        if (currentToken !== token || controller.signal.aborted) return;
        preload.onload = null; preload.onerror = null; pending = null;
        stage.classList.remove('is-changing');
        indicators(displayedIndex);
      };
      preload.sizes = sizes;
      if (selector.dataset.cuonUspSrcset) preload.srcset = selector.dataset.cuonUspSrcset;
      preload.src = source;
    };
    selectors.forEach((el, index) => el.addEventListener('click', () => activate(index, true), options));
    root.querySelectorAll('img').forEach(img => {
      img.addEventListener('error', () => { img.hidden = true; }, options);
      if (img.complete && !img.naturalWidth) img.hidden = true;
    });
    viewport.addEventListener('scroll', () => {
      if (frame || !mobile.matches) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        let nearest = 0;
        selectors.forEach((el, i) => {
          if (Math.abs(el.offsetLeft - viewport.scrollLeft) < Math.abs(selectors[nearest].offsetLeft - viewport.scrollLeft)) nearest = i;
        });
        if (nearest !== activeIndex) activate(nearest);
      });
    }, { ...options, passive: true });
    viewport.addEventListener('keydown', event => {
      let next;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = selectors.length - 1;
      else if (event.key === 'ArrowRight' || (!mobile.matches && event.key === 'ArrowDown')) next = activeIndex + 1;
      else if (event.key === 'ArrowLeft' || (!mobile.matches && event.key === 'ArrowUp')) next = activeIndex - 1;
      else return;
      event.preventDefault();
      activate(next, true);
      selectors[activeIndex].focus({ preventScroll: true });
    }, options);
    root.addEventListener('shopify:block:select', event => {
      const index = selectors.findIndex(el => el.dataset.cuonUspBlockId === event.detail?.blockId);
      if (index >= 0) activate(index, true);
    }, options);
    instances.set(root, () => {
      controller.abort(); cancelPending();
      if (frame) cancelAnimationFrame(frame);
      delete root.dataset.cuonUspReady;
    });
    root.dataset.cuonUspReady = 'true';
    indicators(0);
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-cuon-usp-root]')) init(scope);
    scope.querySelectorAll?.('[data-cuon-usp-root]').forEach(init);
  };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) {
      if (event.target === root || event.target.contains?.(root)) { dispose(); instances.delete(root); }
    }
  });
  window.CuonUspStoryGallery = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuon-whatsapp-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cuon-whatsapp-support')) return;
  const targets = '.cuon-noir-header, [data-cuon-cart], [data-sticky-cart], dialog, [aria-modal="true"]';
  class CuonWhatsAppSupport extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle && !this.lifecycle.signal.aborted) return;
      this.lifecycle = new AbortController();
      const initialize = () => {
        if (!this.querySelector('template')?.content.querySelector('.cuon-wa')) return;
        this.childrenObserver?.disconnect();
        this.initialize();
      };
      this.childrenObserver = new MutationObserver(initialize);
      this.childrenObserver.observe(this, { childList: true, subtree: true });
      initialize();
    }
    initialize() {
      const raw = this.dataset.phone.trim();
      this.phone = /^[+\d\s().-]+$/.test(raw) ? raw.replace(/\D/g, '') : '';
      this.valid = /^[1-9]\d{6,14}$/.test(this.phone);
      this.editor = this.dataset.editor === 'true';
      if (!this.valid && !this.editor) return;
      const { signal } = this.lifecycle;
      this.portal = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.portal.dataset.cwOwner = this.dataset.sectionId;
      this.portal.dataset.cwDesktop = this.dataset.desktop;
      this.portal.dataset.cwMobile = this.dataset.mobile;
      document.body.append(this.portal);
      this.panel = this.portal.querySelector('.cuon-wa__panel');
      this.trigger = this.portal.querySelector('[data-cw-trigger]');
      this.message = this.portal.querySelector('[data-cw-message]');
      this.send = this.portal.querySelector('[data-cw-send]');
      this.updateLink();
      const note = this.portal.querySelector('[data-cw-editor-note]');
      if (note) note.hidden = this.valid;
      this.trigger.addEventListener('click', () => this.panel.hidden ? this.open() : this.close(true), { signal });
      this.portal.querySelector('[data-cw-close]').addEventListener('click', () => this.close(true), { signal });
      this.message.addEventListener('input', () => this.updateLink(), { signal });
      this.send.addEventListener('click', event => {
        this.updateLink();
        if (!this.valid || !this.message.value.trim()) event.preventDefault();
      }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden && this.portal.contains(document.activeElement)) {
          event.preventDefault();
          this.close(true);
        }
      }, { signal });
      document.addEventListener('pointerdown', event => {
        if (!this.panel.hidden && !this.portal.contains(event.target)) this.close(false);
      }, { signal });
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.layout(); });
      };
      this.stateObserver = new MutationObserver(this.schedule);
      this.sizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(this.schedule) : null;
      this.discover();
      this.treeObserver = new MutationObserver(records => {
        const changed = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && !node.matches('.cuon-wa') && (node.matches(targets) || node.querySelector(targets))
        ));
        if (changed) this.discover();
      });
      this.treeObserver.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      window.visualViewport?.addEventListener('scroll', this.schedule, { passive: true, signal });
      document.addEventListener('shopify:section:load', () => this.discover(), { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.disconnectedCallback();
      }, { signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.open();
      }, { signal });
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.close(false);
      }, { signal });
      this.layout();
    }
    updateLink() {
      const message = this.message.value.trim().slice(0, 1500);
      if (this.valid && message) {
        const link = new URL(`https://wa.me/${this.phone}`);
        link.searchParams.set('text', message);
        this.send.href = link.href;
        this.send.removeAttribute('aria-disabled');
        this.send.removeAttribute('tabindex');
      } else {
        this.send.removeAttribute('href');
        this.send.setAttribute('aria-disabled', 'true');
        this.send.setAttribute('tabindex', '-1');
      }
    }
    discover() {
      if (!this.portal || this.lifecycle.signal.aborted) return;
      this.stateObserver.disconnect();
      this.sizeObserver?.disconnect();
      this.watched = [...document.querySelectorAll(targets)].filter(node => !this.portal.contains(node));
      this.bars = this.watched.filter(node => node.matches('[data-sticky-cart]'));
      for (const node of this.watched) {
        this.stateObserver.observe(node, { attributes: true, subtree: node.matches('.cuon-noir-header'), attributeFilter: ['class', 'hidden', 'aria-hidden', 'aria-expanded', 'open', 'style'] });
        if (node.matches('[data-sticky-cart]')) this.sizeObserver?.observe(node);
      }
      this.schedule();
    }
    blocked() {
      return this.watched.some(node => {
        if (!node.isConnected) return false;
        if (node.matches('.cuon-noir-header')) return node.matches('.is-cart-open, .is-mobile-menu-open') || !!node.querySelector('[data-cuon-search-open][aria-expanded="true"]');
        if (node.matches('[data-cuon-cart]')) return node.matches('.is-open') || node.getAttribute('aria-hidden') === 'false';
        if (node.matches('dialog')) return node.open;
        if (node.matches('[aria-modal="true"]') && !node.hidden && node.getAttribute('aria-hidden') !== 'true') return this.visible(node);
        return false;
      });
    }
    visible(node) {
      const style = getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && node.getClientRects().length > 0;
    }
    setVar(name, value) {
      if (this.portal.style.getPropertyValue(name) !== value) this.portal.style.setProperty(name, value);
    }
    layout() {
      if (!this.portal?.isConnected || this.lifecycle.signal.aborted) return;
      const allowed = innerWidth <= 749 ? this.dataset.mobile === 'true' : this.dataset.desktop === 'true';
      if (!allowed || this.blocked()) {
        this.close(false);
        this.portal.inert = true;
        this.portal.hidden = true;
        return;
      }
      this.portal.inert = false;
      this.portal.hidden = false;
      const viewport = window.visualViewport;
      const height = innerHeight;
      const viewBottom = viewport ? Math.min(height, viewport.offsetTop + viewport.height) : height;
      const viewTop = viewport?.offsetTop || 0;
      const style = getComputedStyle(this.portal);
      const base = (parseFloat(style.getPropertyValue('--cw-bottom')) || 0) + (parseFloat(style.marginBottom) || 0);
      const gap = parseFloat(style.getPropertyValue('--cw-gap')) || 14;
      const box = (this.panel.hidden ? this.trigger : this.panel).getBoundingClientRect();
      let lift = 0;
      for (const bar of this.bars) {
        if (!bar.isConnected || !this.visible(bar)) continue;
        const rect = bar.getBoundingClientRect();
        if (rect.bottom > viewTop && rect.top < viewBottom && rect.right > box.left && rect.left < box.right) lift = Math.max(lift, viewBottom - rect.top + gap - base);
      }
      const size = this.trigger.getBoundingClientRect().height;
      this.setVar('--cw-keyboard', `${Math.max(0, height - viewBottom)}px`);
      this.setVar('--cw-lift', `${Math.max(0, lift)}px`);
      this.setVar('--cw-room', `${Math.max(48, viewBottom - viewTop - base - lift - size - 28)}px`);
      this.portal.dataset.ready = 'true';
    }
    open() {
      this.layout();
      if (this.portal.hidden) return;
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.layout();
      this.panel.focus({ preventScroll: true });
    }
    close(restore) {
      if (!this.panel || this.panel.hidden) return;
      if (this.panel.contains(document.activeElement)) {
        if (restore && !this.portal.hidden) this.trigger.focus({ preventScroll: true });
        else document.activeElement.blur();
      }
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.schedule?.();
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.childrenObserver?.disconnect();
      this.stateObserver?.disconnect();
      this.treeObserver?.disconnect();
      this.sizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.portal?.contains(document.activeElement)) document.activeElement.blur();
      this.portal?.remove();
      this.portal = null;
    }
  }
  customElements.define('cuon-whatsapp-support', CuonWhatsAppSupport);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
